import { render } from "./SpecialProduct.vue?vue&type=template&id=41bd34a5&scoped=true"
import script from "./SpecialProduct.vue?vue&type=script&lang=ts"
export * from "./SpecialProduct.vue?vue&type=script&lang=ts"

import "./SpecialProduct.vue?vue&type=style&index=0&id=41bd34a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41bd34a5"

export default script